import { LinearProgress, Typography } from '@mui/material';

import { Color, useProgressBarStyles } from './useProgressBarStyles';

export interface IProgressBarProps {
  className?: string;
  color?: Color;
  max?: number;
  maxLabel?: string;
  progress?: number;
  progressLabel?: React.ReactNode;
  variant?: 'medium' | 'small';
}

export const ProgressBar = ({
  className,
  color,
  max = 100,
  maxLabel,
  progress,
  progressLabel,
  variant = 'medium',
}: IProgressBarProps) => {
  const { classes } = useProgressBarStyles(color);

  const labelVariant = variant === 'small' ? 'body4' : 'body3';

  return (
    <div className={className}>
      <div className={classes.progressLabels}>
        {progressLabel}
        {maxLabel && (
          <Typography
            className={classes.labelText}
            variant={labelVariant}
            color="textSecondary"
          >
            {maxLabel}
          </Typography>
        )}
      </div>
      <LinearProgress
        className={classes.linearProgress}
        color={color}
        value={progress}
        valueBuffer={max}
        variant="determinate"
      />
    </div>
  );
};
